export default "__VITE_ASSET__b4af921d__"